(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    const initParallax = () => {
    const items = document.querySelectorAll('.parallax-scroll:not(.parallax-ready)');
    if (items.length === 0) return;

    const update = () => {
      const winH = window.innerHeight;
      items.forEach(item => {
        const rect = item.getBoundingClientRect();
        if (rect.top < winH && rect.bottom > 0) {
          const speed = parseFloat(item.dataset.parallaxSpeed) || 0;
          // Raw scroll progress through the viewport:
          //   0   = element just entering at the bottom
          //   0.5 = element centered (i.e. "half scrolled")
          //   1   = element just leaving at the top
          const rawProgress = (winH - rect.top) / (winH + rect.height);
          // End the parallax effect once the section is half-scrolled —
          // image locks at translateY(0) for the second half of the scroll.
          const progress = Math.min(rawProgress, 0.5);
          // More extreme movement: 4x the previous magnitude.
          const movement = (progress - 0.5) * 400 * speed;
          item.style.transform = `translateY(${movement}px)`;
        }
      });
      requestAnimationFrame(update);
    };

    items.forEach(item => item.classList.add('parallax-ready'));
    requestAnimationFrame(update);
  };

  document.addEventListener('DOMContentLoaded', initParallax);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initParallax);
    document.addEventListener('shopify:block:select', initParallax);
  }
  initParallax();
  } catch(e) { console.error(e); }
})();

})();
